// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"UnitsAmenitiesTab__listWrapper___2Xzyh"};